import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function nextPage({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        d="M18 12l.707-.707.707.707-.707.707L18 12zM6 13a1 1 0 110-2v2zm8.707-5.707l4 4-1.414 1.414-4-4 1.414-1.414zm4 5.414l-4 4-1.414-1.414 4-4 1.414 1.414zM18 13H6v-2h12v2z"
      />
    </svg>
  );
}

export default nextPage;
